<div
  class="ui-dt"
  [class.ui-dt--actions-scroll]="!stickyActionsColumn()"
>

  <!-- ══ TOOLBAR ══════════════════════════════════════════════════════ -->
  @if (showToolbarBar()) {
  <ui-data-table-toolbar
    [title]="title()"
    [showStatusFilter]="showStatusFilter()"
    [statusFilters]="statusFilters()"
    [segmentedFilters]="segmentedFilters()"
    [toolbarSelects]="toolbarSelects()"
    [pageSizeOptions]="pageSizeOptions"
    [selectedSizeOption]="selectedSizeOption()"
    [showPageSize]="showPageSize()"
    [showNewButton]="showNewButton()"
    [newLabel]="newLabel()"
    [showExcel]="showExcel()"
    (statusFiltersChange)="onFilterMenuChange($event)"
    (segmentedFiltersChange)="segmentedFiltersChange.emit($event)"
    (toolbarSelectsChange)="toolbarSelectsChange.emit($event)"
    (pageSizeChange)="onSizeChange($event)"
    (exportExcel)="onExportExcel()"
    (newClick)="onNew()"
  >
    <ng-container ngProjectAs="[data-toolbar-selects]">
      <ng-content select="[data-toolbar-selects]"></ng-content>
    </ng-container>
    <ng-container ngProjectAs="[data-toolbar-actions]">
      <ng-content select="[data-toolbar-actions]"></ng-content>
    </ng-container>
  </ui-data-table-toolbar>
  }

  <!-- ══ CHIPS DE FILTROS ACTIVOS ══════════════════════════════════════ -->
  @if (activeFilterChips().length) {
    <div class="ui-dt__chips-row">
      @for (chip of activeFilterChips(); track chip.key) {
        <span class="ui-dt__chip-filter">
          {{ chip.label }}
          <button type="button" class="ui-dt__chip-remove" (click)="removeFilterChip(chip.groupPrefix, chip.value)" aria-label="Quitar filtro">
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </span>
      }
    </div>
  }

  <!-- ══ TABLA ═════════════════════════════════════════════════════════ -->
  <div
    class="ui-dt__scroll"
    [class.ui-dt__scroll--vertical]="verticalScroll()"
    [class.ui-dt__scroll--fit]="tableWidth() === '100%'"
    [style.max-height]="scrollViewportHeight()"
  >
    <table
      class="ui-dt__table"
      [class.ui-dt__table--ready]="columnsReady()"
      [style.width]="tableWidth()"
    >

      <!-- Column widths -->
      <colgroup>
        @if (selectable()) {
          <col [style.width]="selectionColWidth()">
        }
        @for (col of columns(); track col.key) {
          <col [style.width]="colWidths()[col.key]">
        }
        @if (showActionsColumn()) {
          <col style="width: 48px">
        }
      </colgroup>

      <!-- Headers -->
      <thead>
        <tr class="ui-dt__head-row">
          @if (selectable()) {
            <th
              class="ui-dt__th ui-dt__th--select"
              [style.width]="selectionColWidth()"
              (click)="$event.stopPropagation()"
            >
              <span class="ui-dt__th-inner">
                <ui-checkbox
                  class="ui-dt__select-check"
                  [checked]="allVisibleSelected()"
                  [indeterminate]="selectAllIndeterminate()"
                  [disabled]="visibleSelectableKeys().length === 0"
                  (checkedChange)="onToggleAll($event)"
                />
              </span>
            </th>
          }
          @for (col of columns(); track col.key) {
            <th
              class="ui-dt__th"
              [class.ui-dt__th--truncate]="col.truncate"
              [class.ui-dt__th--sortable]="isColumnSortable(col)"
              [class.ui-dt__th--sorted]="isColumnSortable(col) && sortState()?.sortBy === col.key"
              [class.ui-dt__sticky-left]="col.sticky === 'left'"
              [class.ui-dt__sticky-left--edge]="isLastStickyLeft(col)"
              [style.left.px]="stickyLeft(col)"
              (click)="onHeaderClick(col)"
            >
              <span class="ui-dt__th-inner">
                {{ col.header }}
                @if (isBooleanCheckboxColumn(col)) {
                  <span class="ui-dt__col-check" (click)="$event.stopPropagation()">
                    <ui-checkbox
                      class="ui-dt__select-check"
                      [checked]="isColumnAllChecked(col)"
                      [indeterminate]="isColumnCheckIndeterminate(col)"
                      [disabled]="isColumnCheckDisabled(col)"
                      (checkedChange)="onToggleColumnCheck(col, $event)"
                    />
                  </span>
                }
                @if (isColumnSortable(col)) {
                  <span class="ui-dt__sort-icon">
                    @if (sortState()?.sortBy === col.key && sortState()?.order === 'asc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>
                    } @else if (sortState()?.sortBy === col.key && sortState()?.order === 'desc') {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                    } @else {
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"/>
                      </svg>
                    }
                  </span>
                }
              </span>
            </th>
          }
          @if (showActionsColumn()) {
            <th class="ui-dt__th ui-dt__th--actions"></th>
          }
        </tr>

        <!-- Fila de filtros por columna -->
        @if (showColumnFilters()) {
          <tr class="ui-dt__filter-row">
            @if (selectable()) {
              <th class="ui-dt__filter-cell ui-dt__filter-cell--select"></th>
            }
            @for (col of columns(); track col.key) {
              <th
                class="ui-dt__filter-cell"
                [class.ui-dt__sticky-left]="col.sticky === 'left'"
                [class.ui-dt__sticky-left--edge]="isLastStickyLeft(col)"
                [style.left.px]="stickyLeft(col)"
              >
                @if (col.filterType === 'select') {
                  <ui-select
                    class="ui-dt__filter-select"
                    [options]="filterOptionsOf(col)"
                    [selected]="filterSelectedOption(col)"
                    [showLabel]="false"
                    [showOptionalHint]="false"
                    [showMessage]="false"
                    [showSearch]="false"
                    [block]="true"
                    [fitPanelToContent]="true"
                    placeholder="Todos"
                    (selectedChange)="onColumnFilterSelect(col.key, $event)"
                  />
                } @else if (col.filterType === 'multiselect') {
                  <ui-multiselect
                    class="ui-dt__filter-multiselect"
                    [options]="filterOptionsOf(col)"
                    [selected]="filterSelectedMultiOptions(col)"
                    [showLabel]="false"
                    [showOptionalHint]="false"
                    [showMessage]="false"
                    [block]="true"
                    [fitPanelToContent]="true"
                    [maxChipsVisible]="1"
                    placeholder="Todos"
                    (selectedChange)="onColumnFilterMulti(col.key, $event)"
                  />
                } @else if (col.filterType !== 'none') {
                  <input
                    class="ui-dt__filter-input"
                    type="text"
                    placeholder="Buscar..."
                    [value]="filterValue(col.key)"
                    (input)="onColumnFilter(col.key, $any($event.target).value)"
                  />
                }
              </th>
            }
            @if (showActionsColumn()) {
              <th class="ui-dt__filter-cell ui-dt__filter-cell--actions"></th>
            }
          </tr>
        }
      </thead>

      <!-- Body -->
      <tbody>
        @if (loading()) {
          @for (s of skeletonRows; track $index) {
            <tr class="ui-dt__row">
              @if (selectable()) {
                <td class="ui-dt__td ui-dt__td--select"><div class="ui-dt__skeleton ui-dt__skeleton--sm"></div></td>
              }
              @for (col of columns(); track col.key) {
                <td
                  class="ui-dt__td"
                  [class.ui-dt__sticky-left]="col.sticky === 'left'"
                  [class.ui-dt__sticky-left--edge]="isLastStickyLeft(col)"
                  [style.left.px]="stickyLeft(col)"
                ><div class="ui-dt__skeleton"></div></td>
              }
              @if (showActionsColumn()) {
                <td class="ui-dt__td"><div class="ui-dt__skeleton ui-dt__skeleton--sm"></div></td>
              }
            </tr>
          }
        } @else if (pagedRows().length === 0) {
          <tr>
            <td [attr.colspan]="colspan()" class="ui-dt__empty">
              <div class="ui-dt__empty-content">
                <span class="ui-dt__empty-icon" aria-hidden="true"></span>
                <span>No existen registros</span>
              </div>
            </td>
          </tr>
        } @else {
          @for (row of pagedRows(); track trackRow($index, row); let idx = $index) {
            <tr
              class="ui-dt__row"
              [class.ui-dt__row--clickable]="clickableRows()"
              [class.ui-dt__row--menu-open]="actionMenu()?.rowIndex === idx"
              [class.ui-dt__row--editable]="editable()"
              [class.ui-dt__row--draft]="isDraftRow(row)"
              (click)="onRowClick(row, $event)"
            >
              @if (selectable()) {
                <td
                  class="ui-dt__td ui-dt__td--select"
                  (click)="$event.stopPropagation()"
                >
                  @if (!isDraftRow(row)) {
                    <ui-checkbox
                      class="ui-dt__select-check"
                      [checked]="isRowSelected(row)"
                      (checkedChange)="onToggleRow(row, $event)"
                    />
                  }
                </td>
              }
              @for (col of columns(); track col.key) {
                <td
                  class="ui-dt__td"
                  [class.ui-dt__td--truncate]="col.truncate"
                  [class.ui-dt__td--editing]="isCellEditable(col)"
                  [class.ui-dt__td--wrap]="col.wrap"
                  [class.ui-dt__td--check]="isBooleanCheckboxColumn(col)"
                  [class.ui-dt__td--clickable]="isClickableStringCell(col)"
                  [class.ui-dt__sticky-left]="col.sticky === 'left'"
                  [class.ui-dt__sticky-left--edge]="isLastStickyLeft(col)"
                  [style.left.px]="stickyLeft(col)"
                  [attr.data-label]="col.header"
                  [attr.data-column-key]="col.key"
                  [attr.tabindex]="isClickableStringCell(col) ? 0 : null"
                  (click)="onStringCellClick(row, col, $event)"
                  (keydown.enter)="onStringCellClick(row, col, $event)"
                >
                  @if (isCellEditable(col)) {
                    <span class="ui-dt__editor">
                      @switch (editorType(col, row)) {
                        @case ('select') {
                          <ui-select
                            [options]="editorOptions(col, row)"
                            [selected]="editorSelected(row, col)"
                            [showLabel]="false"
                            [showOptionalHint]="false"
                            [showMessage]="false"
                            [block]="true"
                            [fitPanelToContent]="true"
                            placeholder="Selecciona"
                            (selectedChange)="onCellSelect(row, col, $event)"
                          />
                        }
                        @case ('date') {
                          <ui-date-input
                            [value]="editorValue(row, col)"
                            [showLabel]="false"
                            [showOptionalHint]="false"
                            [block]="true"
                            (valueChange)="onCellEdit(row, col, $event)"
                            (blurred)="onEditorBlur()"
                          />
                        }
                        @default {
                          <ui-input
                            [kind]="editorInputKind(col, row)"
                            [placeholder]="col.editPlaceholder ?? ''"
                            [value]="editorValue(row, col)"
                            [showLabel]="false"
                            [showOptionalHint]="false"
                            [showMessage]="false"
                            [block]="true"
                            (valueChange)="onCellEdit(row, col, $event)"
                            (blurred)="onEditorBlur()"
                          />
                        }
                      }
                    </span>
                  } @else if (col.nullable && isNullish(cellValue(row, col))) {
                    <span class="ui-dt__null">—</span>
                  } @else if (col.iconButtons?.length) {
                    <span class="ui-dt__cell-actions">
                      @for (btn of col.iconButtons; track btn.id) {
                        @if (btn.actionIcon) {
                          <ui-icon-action
                            [icon]="btn.actionIcon"
                            [ariaLabel]="btn.ariaLabel"
                            (click)="$event.stopPropagation()"
                            (pressed)="onIconButton(row, col, btn)"
                          />
                        } @else if (btn.asImage) {
                          <button
                            type="button"
                            class="ui-dt__icon-image"
                            [attr.aria-label]="btn.ariaLabel"
                            (click)="onIconButton(row, col, btn, $event)"
                          >
                            <img [src]="btn.iconSrc ?? ''" alt="" />
                          </button>
                        } @else {
                          <ui-button
                            variant="icon"
                            iconBackground="white"
                            [iconSrc]="btn.iconSrc ?? ''"
                            [ariaLabel]="btn.ariaLabel"
                            (pressed)="onIconButton(row, col, btn, $event)"
                          />
                        }
                      }
                    </span>
                  } @else {
                    @switch (col.type) {

                      @case ('string') {
                        @if (cellTagColor(row, col); as tagColor) {
                          <ui-tag
                            [label]="cellLabel(row, col)"
                            [color]="tagColor"
                            appearance="outline"
                          />
                        } @else if (tooltipText(row, col)) {
                          <span [uiTooltip]="tooltipText(row, col)">{{ cellValue(row, col) }}</span>
                        } @else {
                          {{ cellValue(row, col) }}
                        }
                      }

                      @case ('number') {
                        <span class="ui-dt__cell--number">{{
                          col.editType === 'amount'
                            ? formatAmountNumber(cellValue(row, col))
                            : formatNumber(cellValue(row, col))
                        }}</span>
                      }

                      @case ('currency') {
                        <span class="ui-dt__cell--number">{{ formatCurrency(cellValue(row, col)) }}</span>
                      }

                      @case ('date') {
                        {{ formatDate(cellValue(row, col)) }}
                      }

                      @case ('boolean') {
                        @if (isBooleanCheckboxColumn(col)) {
                          @if (isCellVisible(row, col)) {
                            <span class="ui-dt__col-check" (click)="$event.stopPropagation()">
                              <ui-checkbox
                                class="ui-dt__select-check"
                                [checked]="!!cellValue(row, col)"
                                (checkedChange)="onToggleBooleanCell(row, col, $event)"
                              />
                            </span>
                          }
                        } @else {
                          <span
                            class="ui-dt__chip"
                            [class.ui-dt__chip--true]="cellValue(row, col)"
                            [class.ui-dt__chip--false]="!cellValue(row, col)"
                          >
                            {{ cellValue(row, col) ? (col.trueLabel ?? 'Sí') : (col.falseLabel ?? 'No') }}
                          </span>
                        }
                      }

                      @case ('link') {
                        <span class="ui-dt__link-cell">
                          {{ cellValue(row, col) }}
                          @if (showLinkButtons() && col.linkKey) {
                            <a
                              class="ui-dt__link-btn"
                              [href]="$any(row)[col.linkKey!]"
                              target="_blank"
                              rel="noopener noreferrer"
                              (click)="$event.stopPropagation()"
                            >{{ col.linkLabel ?? 'Ver' }}</a>
                          }
                        </span>
                      }

                      @case ('avatar') {
                        <span class="ui-dt__avatar-cell">
                          @if (col.avatarKey && $any(row)[col.avatarKey!]) {
                            <img
                              class="ui-dt__avatar-img"
                              [src]="$any(row)[col.avatarKey!]"
                              [alt]="'' + cellValue(row, col)"
                            />
                          } @else {
                            <span class="ui-dt__avatar-placeholder">
                              {{ ('' + cellValue(row, col)).charAt(0).toUpperCase() }}
                            </span>
                          }
                          {{ cellValue(row, col) }}
                        </span>
                      }

                      @case ('projects') {
                        <span class="ui-dt__projects-cell">
                          <span class="ui-dt__projects-badge">{{ projectsList(cellValue(row, col)).length }}</span>
                          <span class="ui-dt__projects-list">{{ projectsList(cellValue(row, col)).join(', ') }}</span>
                        </span>
                      }

                      @case ('string-list') {
                        <span class="ui-dt__string-list">
                          @for (item of projectsList(cellValue(row, col)); track $index) {
                            <span>{{ item }}</span>
                          } @empty {
                            <span class="ui-dt__null">—</span>
                          }
                        </span>
                      }

                      @case ('tags') {
                        @if (isCellVisible(row, col)) {
                          <span class="ui-dt__tags-cell">
                            @for (tag of cellTags(row, col); track tag.label) {
                              @if (col.clickable) {
                                <button
                                  type="button"
                                  class="ui-dt__tag-btn"
                                  (click)="onTagClick(row, col, tag, $event)"
                                >
                                  <ui-tag
                                    [label]="tag.label"
                                    [color]="tagEstatusColor(tag.estatus)"
                                    appearance="outline"
                                  />
                                </button>
                              } @else {
                                <ui-tag
                                  [label]="tag.label"
                                  [color]="tagEstatusColor(tag.estatus)"
                                  appearance="outline"
                                />
                              }
                            } @empty {
                              <span class="ui-dt__null">—</span>
                            }
                          </span>
                        }
                      }

                      @case ('button') {
                        @if (columnButtonVisible(row, col)) {
                          <span class="ui-dt__cell-actions">
                            @if (col.buttonLabels?.length) {
                              @for (label of col.buttonLabels; track label) {
                                <ui-button
                                  variant="ghost"
                                  size="sm"
                                  (pressed)="onColumnButton(row, col, $event, label)"
                                >{{ label }}</ui-button>
                              }
                            } @else {
                              <ui-button
                                variant="ghost"
                                size="sm"
                                (pressed)="onColumnButton(row, col, $event)"
                              >{{ columnButtonLabel(row, col) }}</ui-button>
                            }
                          </span>
                        }
                      }

                    }
                  }
                </td>
              }

              <!-- Columna de acciones -->
              @if (showActionsColumn()) {
                <td
                  class="ui-dt__td ui-dt__td--actions"
                  [class.ui-dt__td--actions--open]="actionMenu()?.rowIndex === idx"
                  (click)="$event.stopPropagation()"
                >
                  @if (rowActions(row).length && !isDraftRow(row)) {
                    <button
                      type="button"
                      class="ui-dt__action-trigger"
                      (click)="openActionMenu($event, row, idx)"
                    >⋮</button>
                  }
                </td>
              }
            </tr>

            <!-- Confirmación del alta inline -->
            @if (isDraftRow(row)) {
              <tr class="ui-dt__draft-row">
                <td class="ui-dt__draft-cell" [attr.colspan]="colspan()">
                  <span class="ui-dt__draft-actions">
                    <ui-button variant="danger" size="sm" (pressed)="onDraftCancel()">
                      Cancelar
                    </ui-button>
                    <ui-button
                      variant="primary"
                      size="sm"
                      [disabled]="draftSaveDisabled()"
                      (pressed)="onDraftSave()"
                    >
                      Guardar
                    </ui-button>
                  </span>
                </td>
              </tr>
            }

            @if (isDetailRow(row)) {
              <tr class="ui-dt__detail-row">
                <td class="ui-dt__detail-cell" [attr.colspan]="colspan()">
                  @if (rowDetail(); as tpl) {
                    <ng-container
                      [ngTemplateOutlet]="tpl"
                      [ngTemplateOutletContext]="{ $implicit: row }"
                    />
                  }
                </td>
              </tr>
            }
          }
        }
      </tbody>

      <!-- Totales -->
      @if (showTotals() && !loading() && pagedRows().length > 0) {
        <tfoot>
          <tr class="ui-dt__totals-row">
            @if (selectable()) { <td class="ui-dt__totals-td ui-dt__totals-td--select"></td> }
            @for (col of columns(); track col.key; let i = $index) {
              <td
                class="ui-dt__totals-td"
                [class.ui-dt__totals-td--truncate]="col.truncate"
                [class.ui-dt__sticky-left]="col.sticky === 'left'"
                [class.ui-dt__sticky-left--edge]="isLastStickyLeft(col)"
                [style.left.px]="stickyLeft(col)"
              >
                @if (i === 0) {
                  <strong>{{ totalLabel() }}</strong>
                } @else if (columnsToTotal().includes(col.key)) {
                  <strong class="ui-dt__cell--number">{{
                    col.type === 'currency'
                      ? formatCurrency(computedTotals()[col.key])
                      : formatNumber(computedTotals()[col.key])
                  }}</strong>
                }
              </td>
            }
            @if (showActionsColumn()) {
              <td class="ui-dt__totals-td ui-dt__totals-td--actions"></td>
            }
          </tr>
        </tfoot>
      }
    </table>
  </div>

  <!-- ══ PAGINACIÓN ════════════════════════════════════════════════════ -->
  @if (!infiniteScroll() && !editable() && showPagination()) {
    <ui-data-table-pagination
      [currentPage]="currentPage()"
      [totalPages]="totalPages()"
      [visiblePages]="visiblePages()"
      [rangeStart]="rangeStart()"
      [rangeEnd]="rangeEnd()"
      [total]="effectiveTotal()"
      (pageSelect)="goToPage($event)"
    />
  }

</div>

<!-- ══ MENÚ DE ACCIONES (fixed, fuera del flujo) ═══════════════════════ -->
@if (actionMenu()) {
  <ui-data-table-actions-menu
    [state]="actionMenu()!"
    [items]="actionMenu()!.items"
    (actionSelect)="onActionItem($event)"
  />
}
